// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__9XVhJ","inner":"Form_inner__2FZAP","range":"Form_range__38cps","name":"Form_name__3jNdw","actions":"Form_actions__3rmiR"};